export const isNumberGreaterThanZero = (
  value?: number | null,
): value is number => typeof value === 'number' && value > 0;
